module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/logo显示模组.eb54edee.png";